export const numbersOnly = (stringValue) => {
    return stringValue.replace(/\D/g,'');
}



// WEBPACK FOOTER //
// ./src/js/utils/stringUtils.js